import AxiosInstance from "./AxiosInstance.js";

import useAPIList from "./useAPIList.js";

export function fetchCourseSurvey(courseId) {
    return AxiosInstance.get(`/api/courses/${courseId}/surveys`).then(res => res.data)
}

export function fetchEventSurvey(eventId) {
    return AxiosInstance.get(`/api/events/${eventId}/surveys`).then(res => res.data)
}

export function fetchTrainingSurvey(trainingId) {
    return AxiosInstance.get(`/api/trainings/${trainingId}/surveys`).then(res => res.data)
}

export function updateSurvey(surveyId, sections) {
    return AxiosInstance.put(`/api/surveys/${surveyId}`, {sections}).then(res => res.data)
}


export function useSurveyResponses(surveyId) {
    return useAPIList(`/api/surveys/${surveyId}/responses`)
}

export function fetchSurveyResponses(surveyId) {
    return AxiosInstance.get(`/api/surveys/${surveyId}/responses`).then(res => res.data)
}

export function submitSurvey(surveyId, answers) {
    return AxiosInstance.post(`/api/surveys/${surveyId}/responses`, { answers }).then(res => res.data)
}

export function hasSubmitted(surveyId) {
    return AxiosInstance.get(`/api/surveys/${surveyId}/responses/my`).then(res => !!res.data)
}